import * as Yup from 'yup';



const baseFilterFields = [ 'id', 'folder', 'category', 'is_main_category', 'is_without_category', 'formats', 'hashtags', 'is_exclude_hashtags', 'tags', 'is_without_tags', 'recommended_types', 'is_exclude_recommended_types', 'taps_from', 'taps_to', 'colors_from', 'colors_to', 'imported_from', 'imported_to', 'released_from', 'released_to' ];

export const searchFilterFields = baseFilterFields;

export const searchFilterFieldsImages = [ ...baseFilterFields, 'status' ];

export const validationSchema = Yup.lazy((values) => {
  const { taps_to, taps_from, released_from, released_to, colors_from, colors_to } = values;

  return Yup.object().shape({
    id: Yup.string(),
    folder: Yup.string(),
    is_main_category: Yup.boolean(),
    hashtags: Yup.array().nullable(),
    is_exclude_hashtags: Yup.boolean(),
    tags: Yup.array().nullable(),
    is_without_tags: Yup.boolean(),
    recommended_types: Yup.array().nullable(),
    is_exclude_recommended_types: Yup.boolean(),
    formats: Yup.array().nullable(),
    imported_from: Yup.date().nullable()
      .before(values?.imported_to, 'Imported from date must be same or before than released to'),
    imported_to: Yup.date().nullable()
      .after(values?.imported_from, 'Imported to date must be same or after than released from'),
    released_from: Yup.date().nullable()
      .before(released_to, 'Released from date must be same or before than released to'),
    released_to: Yup.date().nullable()
      .after(released_from, 'Released to date must be same or after than released from'),
    taps_from: Yup.number().test(
      'check-taps-min',
      'Taps from must be same or before than taps to',
      (value) => value && taps_to ? Number(value) <= Number(taps_to) : true,
    ).nullable(),
    taps_to: Yup.number().test(
      'check-taps-max',
      'Taps to must be same or after than taps from',
      (value) => value && taps_from ? Number(value) >= Number(taps_from) : true,
    ).nullable(),
    colors_from: Yup.number().test(
      'check-colors-min',
      'Colors from must be same or before than colors to',
      (value) => value && colors_to ? Number(value) <= Number(colors_to) : true,
    ).nullable(),
    colors_to: Yup.number().test(
      'check-colors-max',
      'Colors to must be same or after than colors from',
      (value) => value && colors_from ? Number(value) >= Number(colors_from) : true,
    ).nullable(),
  });
});
